<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="'Editar Promoción ' + promocion?.id_promo" titulo="Promociones">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;" *ngIf="promocion">
          <button class="btn btn-outline-success" [routerLink]="['bonificadores']" [queryParams]="{tipo_promo: promocion.tipo_promo, grupos: promocion.suma_por_grupos}" *ngIf="!condicionMarca">
            Bonificadores
          </button>
          <button class="btn btn-outline-success" [routerLink]="['regalos']" [queryParams]="{tipo_promo: promocion.tipo_promo}">
            Regalos
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <div class="mb-3" *ngIf="promocion">
      <app-simple-accordion id="accordionCsv1" header="Opciones de csv">
        <div class="row align-items-end">
          <div class="col-12 col-md-6 col-lg-4" *ngIf="condicionCliente">
            <button class="btn btn-success" (click)="downloadCsv()"><i class="fas fa-file-csv me-1"></i>Condición cliente</button>
          </div>
          <div class="col-12 col-md-6 col-lg-4" *ngIf="condicionGrupoCliente">
            <label for="fileGroup" class="form-label">Agregar condición grupo cliente</label>
            <input type="file" accept=".csv" class="form-control form-control-sm" id="fileGroup" #fileGroupInput (change)="onFileGroup($event)" />
          </div>
          <div class="col-12 col-md-6 col-lg-4" *ngIf="!condicionMarca">
            <label for="fileBonus" class="form-label">Agregar bonos y regalos</label>
            <input type="file" accept=".csv" class="form-control form-control-sm" id="fileBonus" #fileBonosInput (change)="onFileBonos($event)" />
          </div>
        </div>
      </app-simple-accordion>
    </div>
    <app-promocion-form
      [cmbTipoPromocion]="cmbTipoPromocion"
      [promocion]="promocion"
      [loading]="loading"
      (back)="back()"
      (create)="guardar($event)"
      *ngIf="promocion"
    ></app-promocion-form>
  </ng-template>
</div>
